var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vessel-course-unknown-icon",style:(_vm.cssVars)},[(_vm.isSafe)?_c('vessel-course-unknown-safe'):(_vm.isCaution)?_c('vessel-course-unknown-caution'):_c('vessel-course-unknown-danger')],1)}
var staticRenderFns = []

export { render, staticRenderFns }